<header class="navbar navbar-expand-md sticky-top bg-dark flex-md-nowrap p-0 shadow d-print-none" data-bs-theme="dark">
    <a class="navbar-brand col-2 me-0 px-3 fs-6 text-white" [routerLink]="['/']">Ariel Manager</a>
    <ul class="navbar-nav flex-row d-md-none">
        <li class="nav-item text-nowrap">
            <button class="nav-link px-3 text-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu">
                <i class="bi bi-list"></i>
            </button>
        </li>
    </ul>
    <ul class="navbar-nav flex-row d-none d-md-flex ms-auto me-3">
        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="javascript:;" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ (authService.user.name.split(' ')[0]) }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
                <li class="border-top"><button type="button" class="dropdown-item" [routerLink]="['/doctors/profile']"><i class="bi bi-person"></i> Perfil</button></li>
                <li class="border-top"><button type="button" class="dropdown-item" type="button" (click)="authService.logout()" ><i class="bi bi-power"></i> Sair</button></li>
            </ul>
        </li>
    </ul>
</header>